import React from 'react'
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material'
import { CheckCircle, Pix, Schedule } from '@mui/icons-material'

interface PixPaymentProps {
  onSubmit: () => void
  isProcessing: boolean
  totalAmount: number
}

const PixPayment: React.FC<PixPaymentProps> = ({ onSubmit, isProcessing, totalAmount }) => {
  const formatPrice = (price: number) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)

  return (
    <Box>
      <Card sx={{ mb: 3, backgroundColor: 'rgba(50,188,173,0.05)', border: '1px solid rgba(50,188,173,0.2)' }}>
        <CardContent sx={{ p: 3 }}>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Pix sx={{ fontSize: 40, color: '#32BCAD' }} />
            <Box>
              <Typography variant="h6" fontWeight={900}>
                Pagamento via PIX
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Rápido, seguro e sem taxas
              </Typography>
            </Box>
          </Stack>

          <Stack spacing={1.25}>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <CheckCircle sx={{ color: '#4caf50', fontSize: 20 }} />
              <Typography variant="body2">Processado instantaneamente</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Schedule sx={{ color: '#ff9800', fontSize: 20 }} />
              <Typography variant="body2">Pacotes creditados após confirmação</Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>

      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight={900} color="primary" sx={{ mb: 0.5 }}>
          {formatPrice(totalAmount)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Valor total a pagar
        </Typography>
      </Box>

      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={onSubmit}
        disabled={isProcessing}
        startIcon={isProcessing ? <CircularProgress size={20} color="inherit" /> : <Pix />}
        sx={{
          py: 2,
          fontWeight: 900,
          background: 'linear-gradient(45deg, #32BCAD 30%, #26A69A 90%)',
          '&:hover': { background: 'linear-gradient(45deg, #26A69A 30%, #00897B 90%)' },
          '&:disabled': { background: 'rgba(50,188,173,0.30)' }
        }}
      >
        {isProcessing ? 'Processando...' : 'Pagar com PIX'}
      </Button>

      <Alert severity="info" sx={{ mt: 3 }}>
        Após iniciar, abriremos a página de pagamento (se fornecida pelo gateway). Quando confirmado, o pacote será creditado.
      </Alert>
    </Box>
  )
}

export default PixPayment

